<template>
  <div id="loader">

    <div class="loadingio-spinner-rolling-pa5prjg62x">
      <div class="ldio-7hm435x3krf">
        <div></div>
      </div>
    </div>

    <p class="loading-message">{{ loadingMessage }}</p>

  </div>
</template>


<style scoped lang="scss">

  #loader {
    min-height:400px;

    @keyframes ldio-7hm435x3krf {
      0% { transform: translate(-50%,-50%) rotate(0deg); }
      100% { transform: translate(-50%,-50%) rotate(360deg); }
    }
    .ldio-7hm435x3krf div {
      position: absolute;
      width: 103.95px;
      height: 103.95px;
      border: 6.93px solid #85a2b6;
      border-top-color: transparent;
      border-radius: 50%;
    }
    .ldio-7hm435x3krf div {
      animation: ldio-7hm435x3krf 1.9607843137254901s linear infinite;
      top: 115.5px;
      left: 115.5px
    }
    .loadingio-spinner-rolling-pa5prjg62x {
      width: 231px;
      height: 231px;
      display: inline-block;
      overflow: hidden;
      background: none;
    }
    .ldio-7hm435x3krf {
      width: 100%;
      height: 100%;
      position: relative;
      transform: translateZ(0) scale(1);
      backface-visibility: hidden;
      transform-origin: 0 0; /* see note above */
    }
    .ldio-7hm435x3krf div { box-sizing: content-box; }
    /* generated by https://loading.io/ */

  }

</style>

<script>
  export default {
    name: 'Loader',
    props: ['loadingMessage']
  }

</script>
